import { useEffect } from 'react'

import { REDUCED_MOTION } from '@/lib/motion'

/**
 * Publishes a --py offset on every [data-parallax] container as it crosses
 * the frame. The value is read by whatever sits inside it, so the measured
 * box is never the one being transformed.
 */
export const useParallax = (): void => {
    useEffect(() => {
        if (window.matchMedia(REDUCED_MOTION).matches) return

        const nodes = Array.from(document.querySelectorAll<HTMLElement>('[data-parallax]'))

        if (!nodes.length) return

        let raf = 0
        let lastY = -1

        const tick = (): void => {
            raf = requestAnimationFrame(tick)

            if (document.hidden) return

            const y = window.scrollY

            if (y === lastY) return

            lastY = y

            const vh = window.innerHeight

            for (const node of nodes) {
                const rect = node.getBoundingClientRect()

                if (rect.bottom < -240 || rect.top > vh + 240) continue

                const amount = Number(node.dataset.parallax) || 40
                const progress = (rect.top + rect.height / 2 - vh / 2) / vh

                node.style.setProperty('--py', `${(-progress * amount).toFixed(2)}px`)
            }
        }

        raf = requestAnimationFrame(tick)

        return () => cancelAnimationFrame(raf)
    }, [])
}
